// @ts-nocheck
function iconOptionsForColor(color) {
  return {
    path: google.maps.SymbolPath.CIRCLE,
    strokeColor: color,
    fillColor: color,
    fillOpacity: 0.4,
    strokeWeight: 2,
    scale: 10,
  };
}

const highlightColor = '#2196F3';
const defaultColor = '#F44336';
const parentColor = '#3F51B5';

export default class RepeatableMarkerManager {
  constructor(map, onMarkerAdded) {
    this._map = map;
    this._highlightedMarker = null;
    this._markers = {};
    this._onMarkerAdded = onMarkerAdded;
  }

  updateMarkers(markers) {
    const currentMarkerIds = Object.keys(this._markers);
    const newMarkerIds = [];

    if (!markers) {
      return;
    }

    for (const marker of markers.toArray()) {
      const markerOpts = marker.toJS();
      const { id } = markerOpts.data.feature;

      newMarkerIds.push(id);

      const color = markerOpts.data.parent ? parentColor : defaultColor;

      const markerOptions = {
        position: markerOpts.location,
        icon: iconOptionsForColor(color),
        data: markerOpts.data,
        title: markerOpts.title,
      };

      const circle = new google.maps.Marker(markerOptions);

      this._markers[id] = circle;

      circle.setMap(this._map);

      this._onMarkerAdded(circle);
    }

    currentMarkerIds.forEach((markerId) => {
      if (!newMarkerIds.includes(markerId)) {
        this._markers[markerId].setMap(null);
        delete this._markers[markerId];
      }
    });
  }

  updateHighlighted(marker) {
    Object.keys(this._markers).forEach((markerId) => {
      const _marker = this._markers[markerId];

      if (!_marker.data.parent) {
        let isHighlighted = false;

        if (marker && _marker.data.feature.id === marker.id) {
          isHighlighted = true;
        }

        const icon = iconOptionsForColor(isHighlighted ? highlightColor : defaultColor);
        _marker.setIcon(icon);
      }
    });
  }

  get isEmpty() {
    return Object.keys(this._markers).length === 0;
  }
}
